import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { ListTagsDTO } from '../../dto/tags'
import { store } from '../../store'

export const listTags = async () => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/tags`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_TAGS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_TAGS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_TAGS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListTagsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_TAGS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_TAGS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_TAGS_OK', tagGroups: body.tagGroups } )

}
